<div class="page-body">
  <div class="page-body__content">
    <ng-content />
  </div>
</div>
